<template>
  <div class="expert-tool-history">
    <history-stats></history-stats>
    <div class="expert-tool-history__main">
      <div class="expert-tool-history__left">
        <history-prescription-comparison></history-prescription-comparison>
        <history-prescriptions-table></history-prescriptions-table>
      </div>
      <div class="expert-tool-history__right">
        <history-comparison></history-comparison>
      </div>
    </div>
    <unsaved-changes-warning ref="unsavedChangesWarning"></unsaved-changes-warning>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HistoryStats from './HistoryStats';
import HistoryPrescriptionsTable from './HistoryPrescriptionsTable';
import HistoryPrescriptionComparison from './HistoryPrescriptionComparison';
import HistoryComparison from './HistoryComparison';
import UnsavedChangesWarning from "../../../components/Parts/UnsavedChangesWarning.vue";

/**
 * Component HistoryMain.vue
 *
 * @module HistoryMain
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [deprecated] app/src/APP_DASHBOARD/templates/views/ExpertTool/History/HistoryMain.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'HistoryMain',
  components: {
    HistoryStats,
    HistoryPrescriptionsTable,
    HistoryPrescriptionComparison,
    HistoryComparison,
    UnsavedChangesWarning
  },
  computed: {
    ...mapGetters({
      unsavedChanges: 'patientSummary/unsavedChanges'
    }),
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'PatientExpertToolSafetyPrecautions'
      || to.name === 'PatientExpertToolSportsGoal') {
        next();
    }
    if ((this.unsavedChanges())) {
      this.$refs.unsavedChangesWarning.prepareToExit(to.name)
      return false;
    }
    next();
  }
};
</script>

<style lang="scss">
.expert-tool-history__main {
  display: flex;
}

.expert-tool-history__left {
  flex-grow: 1;
}
</style>
